import * as React from 'react';
import { SideMenuProps } from './side-menu';
import { SideMenuItemProps } from './side-menu-item';

export type SideMenuItemRenderer = (
    buttonText: React.ReactNode,
    itemProps: SideMenuItemProps,
    linkProps: Record<string, string>,
) => React.ReactNode;

export interface SideMenuContextShape {
    props: SideMenuProps;
    selectedActual: string;
    setSelectedActual: (value: string) => void;
    expandedItems: string[];
    setExpandedItems: (value: string[]) => void;
    itemRenderer?: SideMenuItemRenderer;
}

export const SideMenuContext = React.createContext<SideMenuContextShape>(null);

SideMenuContext.displayName = 'SideMenuContext';
